module.exports = "/static/assets/a342662276e858f9d8bab7bbf17a61c6.png";